import React, { MouseEventHandler, ReactNode } from "react"
import { useParams } from "react-router"

import { useAccount, useLayerPopupContext } from "@shared/contexts"
import { open as popupOpen } from "@shared/modules"
import { Params } from "@shared/types"

import LinkItem from "./LinkItem"

interface Props {
  title: string
  children: ReactNode
}

const ChatView = ({ title, children }: Props) => {
  const { scheduleId, streamerName } = useParams<Params>()
  const { open } = useLayerPopupContext()
  const { account } = useAccount()
  const isAnonymous = account?.viewer?.role === "ANONYMOUS"

  const handleChatView: MouseEventHandler<HTMLAnchorElement> = (e) => {
    e.preventDefault()
    if (isAnonymous) return open("ANONYMOUS")

    popupOpen(
      `/${streamerName}/${scheduleId}/chat-histories`,
      "chatHistories",
      "width=500px,height=650px,menubar=no,location=no,resizable=yes",
    )
  }

  return (
    <LinkItem className="ty03" title={title} onClick={handleChatView}>
      {children}
    </LinkItem>
  )
}

export default ChatView
